/**
 * ABP Permission Constants
 *
 * These constants match the backend permissions defined in:
 * backend/learnleaf/src/learnleaf.Application.Contracts/Permissions/learnleafPermissions.cs
 *
 * IMPORTANT: Keep this file in sync with backend permissions.
 * Any new permissions added to the backend should be added here.
 */

export const AbpPermissions = {
  // Book Management
  ReadBook: 'learnleaf.App.ReadBook',
  UploadBook: 'learnleaf.App.UploadBook',
  ManageBooks: 'learnleaf.App.ManageBooks',

  // License Management
  BulkAssignLicenses: 'learnleaf.App.BulkAssignLicenses',
  ManageLicenses: 'learnleaf.App.ManageLicenses',
  RevokeLicense: 'learnleaf.App.RevokeLicense',
  SuspendLicense: 'learnleaf.App.SuspendLicense',

  // Publisher Management
  ManagePublishers: 'learnleaf.App.ManagePublishers',

  // Bookseller Management
  ManageBooksellers: 'learnleaf.App.ManageBooksellers',
  ManageBooksellerTts: 'learnleaf.App.ManageBooksellerTts',

  // Session Management
  ViewSessions: 'learnleaf.App.ViewSessions',
  TerminateSession: 'learnleaf.App.TerminateSession',

  // DRM & Quotas
  ViewDrmQuotas: 'learnleaf.App.ViewDrmQuotas',
  ManageDrmQuotas: 'learnleaf.App.ManageDrmQuotas',
  RequestPrint: 'learnleaf.App.RequestPrint',
  RequestDownload: 'learnleaf.App.RequestDownload',

  // System Administration
  ViewHangfireDashboard: 'learnleaf.App.ViewHangfireDashboard',
  ViewAuditLogs: 'learnleaf.App.ViewAuditLogs',
  ManageSystemSettings: 'learnleaf.App.ManageSystemSettings',

  // Missing Books Report
  ViewMissingBooks: 'learnleaf.App.ViewMissingBooks',
  ResolveMissingBooks: 'learnleaf.App.ResolveMissingBooks',

  // Language Management (ABP built-in)
  ManageLanguages: 'LanguageManagement.Languages',
  ManageLanguageTexts: 'LanguageManagement.LanguageTexts',
} as const;

/**
 * Type for permission values
 * Ensures type safety when passing permissions to hooks/components
 */
export type AbpPermission = typeof AbpPermissions[keyof typeof AbpPermissions];

/**
 * Helper type to check if a string is a valid ABP permission
 */
export type IsAbpPermission<T extends string> = T extends AbpPermission ? T : never;
